import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsersDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16ZM16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0ZM19.2308 10.8462L17.3846 9H14.6154L12.7692 10.8462H10V12.6923H22V10.8462H19.2308ZM10.9231 23.7692V13.6154H21.0769V23.7692H10.9231Z",
		fill: "#FF3131",
		fillOpacity: .8
	})
});
export default SvgUsersDelete;
